import React, { useState, useEffect, useContext } from "react";
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Box, Backdrop, CircularProgress } from '@mui/material'
import { Button } from '@material-ui/core';
import { generateClient } from 'aws-amplify/api';
import Alert from '@mui/material/Alert';
import * as queries from '../graphql/queries'

import TerminalListTable from "../components/TerminalListTable";
import TitleHeader from "../components/TitleHeader";

import UserContext from "../context/UserContext"

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        flex: 1,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center'
    },
    container: {
        width: '90%',
        margin: '0 auto'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    } 
}))

/**
 * 端末管理ページ
 * @param {*} props 
 * @returns 
 */
const OTAServerManagementPage = (props) => {
    // ユーザグループ取得
    const ADMIN_USER_GROUP_NAME = process.env.REACT_APP_ADMIN_GID
    const userContext = useContext(UserContext)
    const [userGroups, setUserGroups] = useState([])
    const [isAdmin, setIsAdmin] = useState(false)
    const [userGroupsLoaded, setUserGroupsLoaded] = useState(false)

    const classes = useStyles()
    const [dispErrSettingsBtnMsg, setDispErrSettingsBtnMsg] = useState()
    const [terminalList, setTerminalList] = useState([])
    const [open, setOpen] = useState(false)

    const client = generateClient()

    useEffect(() => {
        const fetchUserGroups = async () => {
            const groups = await userContext.getCurrentUserGroup()
            if (groups) {
                const adminStatus = groups.includes(ADMIN_USER_GROUP_NAME)
                setUserGroups(groups)
                setIsAdmin(adminStatus)
                setUserGroupsLoaded(true)
            }
        }
        fetchUserGroups()
    }, [userContext, ADMIN_USER_GROUP_NAME])

    useEffect(() => {
        // Only run when user groups are fully loaded
        if (!userGroupsLoaded) return;

        // 端末最新情報取得
        const loadTerminalData = async() => {
            console.log('[Loading] Starting data load...')
            setOpen(true)
            try {
                let latestData
                if(isAdmin) {
                    // 全ての端末情報を取得する
                    console.log('[Loading] Fetching admin data...')
                    latestData = await allTerminalRequest()
                    console.log('[Loading] Admin data loaded:', latestData.length, 'items')
                } else {
                    // GroupIdの当てはまる端末情報を取得する。
                    console.log('[Loading] Fetching group data for:', userGroups[0])
                    latestData = await allTerminalRequestByGroupId()
                    console.log('[Loading] Group data loaded:', latestData.length, 'items')
                }
                setTerminalList(latestData)
                console.log('[Loading] Terminal list updated')
            } catch (error) {
                console.error('[Loading] Error loading terminal data:', error)
            } finally {
                console.log('[Loading] Setting loading indicator to false')
                setOpen(false)
            }
        }

        loadTerminalData()

    }, [userGroupsLoaded, isAdmin])

    const allTerminalRequest = async() => {
        let nextToken = null
        const retTerminalList = []
        let pageCount = 0
        do {
            pageCount++
            console.log(`[Pagination] Loading page ${pageCount}...`)
            try {
                const response = await client.graphql({
                    query: queries.listTerminalLatestData,
                    variables: {nextToken: nextToken, limit: 1000, filter: {Model: {attributeExists: true}}}
                })
                const termnalLatestData = response.data.listRegisteredTerminals.items
                nextToken = response.data.listRegisteredTerminals.nextToken
                retTerminalList.push(...termnalLatestData)
                console.log(`[Pagination] Page ${pageCount} loaded: ${termnalLatestData.length} items, Total: ${retTerminalList.length}, Has more: ${!!nextToken}`)
            } catch (e) {
                console.error(`[Pagination] Error on page ${pageCount}:`, e)
                nextToken = null
            }
        } while (nextToken)
        console.log(`[Pagination] All pages loaded. Total: ${retTerminalList.length} items`)
        return retTerminalList
    }

    const allTerminalRequestByGroupId = async() => {
        let nextToken = null
        const retTerminalList = []
        let pageCount = 0
        do {
            pageCount++
            console.log(`[Pagination GroupId] Loading page ${pageCount}...`)
            try {
                const response = await client.graphql({
                    query: queries.listTerminalLatestDataByGroupId,
                    variables: {GroupId: userGroups[0], nextToken: nextToken}
                })
                const termnalLatestData = response.data.listRegisteredTerminals.items
                nextToken = response.data.listRegisteredTerminals.nextToken
                retTerminalList.push(...termnalLatestData)
                console.log(`[Pagination GroupId] Page ${pageCount} loaded: ${termnalLatestData.length} items, Total: ${retTerminalList.length}, Has more: ${!!nextToken}`)
            } catch (e) {
                console.error(`[Pagination GroupId] Error on page ${pageCount}:`, e)
                nextToken = null
            }
        } while (nextToken)
        console.log(`[Pagination GroupId] All pages loaded. Total: ${retTerminalList.length} items`)
        return retTerminalList
    }
    const onClickSettingsBtn = () => {
        const selectedList = terminalList.filter(row => row.tableData.checked).map(row => row['MAC'])
        if(selectedList.length) {
            setDispErrSettingsBtnMsg(false)
            props.history.push({pathname: '/setting', checkedMACList: selectedList})
        } else {
            setDispErrSettingsBtnMsg(true)
        }
    }
    const onClickMapBtn = async() => {
        props.history.push({pathname: '/map'})
    }

    const onClickTerminalRegistration = () => {
        props.history.push({pathname: '/registration'})
    }

    return (
        <Box className={classes.root}>
            <Box className={classes.container}>
                <TitleHeader history={props.history}/>
                <Box sx={
                    {justifyContent: 'flex-start', alignItems: 'flex-start'}
                } style={{display: 'flex', marginBlock: '10px'}}>
                    <Button variant="outlined" onClick={onClickSettingsBtn}>Settings for selected items</Button>
                    <Button variant="outlined" onClick={onClickTerminalRegistration} style={{marginLeft: '10px'}}>DEVICE Registration</Button>
                    <Button variant="outlined" onClick={onClickMapBtn}  style={{marginLeft: '10px'}}>Device Map</Button>
                </Box>
                {dispErrSettingsBtnMsg && <Alert severity="error">Please select one or more</Alert>}                
                <TerminalListTable terminalList={[...terminalList]} history={props.history} />
            </Box>
            <Backdrop open={open} className={classes.backdrop} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    )
}

export default OTAServerManagementPage;